export enum GqlErrorCode {
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
  EMAIL_RESERVED_INTERNAL = 'EMAIL_RESERVED_INTERNAL',
  EMAIL_ALREADY_IN_USE_WITH_UNSET_PASSWORD = 'EMAIL_ALREADY_IN_USE_WITH_UNSET_PASSWORD',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  INCORRECT_EMAIL_OR_PASSWORD = 'INCORRECT_EMAIL_OR_PASSWORD',
  UNSET_PASSWORD = 'UNSET_PASSWORD',
  SHORT_PASSWORD = 'SHORT_PASSWORD',
  WEAK_PASSWORD_SYMBOLS = 'WEAK_PASSWORD_SYMBOLS',
  WEAK_PASSWORD_WELL_KNOWN = 'WEAK_PASSWORD_WELL_KNOWN',
  CURRENT_PASSWORD_DOES_NOT_MATCH = 'CURRENT_PASSWORD_DOES_NOT_MATCH',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_MOBILE_NUMBER = 'INVALID_MOBILE_NUMBER',
  REFILL_COOLDOWN_PERIOD = 'REFILL_COOLDOWN_PERIOD',
  REQUEST_PROCESSING = 'REQUEST_PROCESSING',
  IHI_DUPLICATE_IHI = 'IHI_DUPLICATE_IHI',
  IHI_MISMATCHING_RECORDS = 'IHI_MISMATCHING_RECORDS',
  IHI_NO_RECORDS_FOUND = 'IHI_NO_RECORDS_FOUND',
  INVALID_QUIZ_ANSWER_REQUIRED = 'INVALID_QUIZ_ANSWER_REQUIRED',
  INVALID_QUIZ_ANSWER_HEIGHT_CENTIMETERS = 'INVALID_QUIZ_ANSWER_HEIGHT_CENTIMETERS',
  INVALID_QUIZ_ANSWER_HEIGHT_NUMBER = 'INVALID_QUIZ_ANSWER_HEIGHT_NUMBER',
  INVALID_QUIZ_ANSWER_WEIGHT_KILOGRAMS = 'INVALID_QUIZ_ANSWER_WEIGHT_KILOGRAMS',
  INVALID_QUIZ_ANSWER_WEIGHT_NUMBER = 'INVALID_QUIZ_ANSWER_WEIGHT_NUMBER',
  INVALID_QUIZ_ANSWER_WAIST_CLOTHING_SIZE = 'INVALID_QUIZ_ANSWER_WAIST_CLOTHING_SIZE',
  INVALID_QUIZ_ANSWER_WAIST_NUMBER = 'INVALID_QUIZ_ANSWER_WAIST_NUMBER',
  INVALID_QUIZ_ANSWER_WAIST_INCHES = 'INVALID_QUIZ_ANSWER_WAIST_INCHES',
  INVALID_QUIZ_ANSWER_DATE_INVALID = 'INVALID_QUIZ_ANSWER_DATE_INVALID',
  INVALID_QUIZ_ANSWER_DATE_MUST_BE_PAST = 'INVALID_QUIZ_ANSWER_DATE_MUST_BE_PAST',
  PAYMENT_INSUFFICIENT_FUNDS = 'PAYMENT_INSUFFICIENT_FUNDS',
  PAYMENT_CARD_DECLINED = 'PAYMENT_CARD_DECLINED',
  PAYMENT_CARD_NUMBER_INCORRECT = 'PAYMENT_CARD_NUMBER_INCORRECT',
  PAYMENT_CARD_EXPIRED = 'PAYMENT_CARD_EXPIRED',
  PAYMENT_CARD_INVALID = 'PAYMENT_CARD_INVALID',
  PAYMENT_INCORRECT_SECURITY_CODE = 'PAYMENT_INCORRECT_SECURITY_CODE',
  PAYMENT_METHOD_NOT_ATTACHED = 'PAYMENT_METHOD_NOT_ATTACHED',
  CANNOT_RESCHEDULE_ORDER = 'CANNOT_RESCHEDULE_ORDER',
  SCRIPT_EXPIRED_FOLLOW_UP_CREATED = 'SCRIPT_EXPIRED_FOLLOW_UP_CREATED',
  RESET_PASSWORD_LINK_EXPIRED = 'RESET_PASSWORD_LINK_EXPIRED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  ADDRESS_STATE_REQUIRED = 'ADDRESS_STATE_REQUIRED',
  SHIPPING_ADDRESS_OUT_OF_RANGE = 'SHIPPING_ADDRESS_OUT_OF_RANGE',
  COUPON_EXPIRED = 'COUPON_EXPIRED',
  COUPON_NOT_FOUND = 'COUPON_NOT_FOUND',
  COUPON_EXHAUSTED = 'COUPON_EXHAUSTED',
  COUPON_UNKNOWN_ERROR = 'COUPON_UNKNOWN_ERROR',
}
